module.exports = __webpack_public_path__ + "img/Component3.def7ada9.png";